// Deemed Cancellation — Phase 4 service (Deemed tab + CRM-Head actions).
// Talks to SALES backend routes/deemedCancellation.js via REACT_APP_PAYMENT_LINK_URL.
import axios from "axios";
import { supabase } from "../supabaseClient";

const BASE = process.env.REACT_APP_PAYMENT_LINK_URL;
const EXTENSION_BUCKET = "AllotmentLetter"; // reuse existing bucket; files under deemed_extensions/

// GET monitoring cards for the Deemed tab.
async function getDeemedList(includeClosed = false) {
  const res = await axios.get(`${BASE}deemedCancellation/list`, { params: { includeClosed } });
  return res?.data?.data || [];
}

// CRM Head grants an extension (target date + reason + attachment all mandatory).
async function grantExtension(body) {
  const res = await axios.post(`${BASE}deemedCancellation/grantExtension`, body);
  return res?.data;
}

// CRM Head confirms cancellation (mandatory reason). Cron executes the release.
async function confirmCancellation(body) {
  const res = await axios.post(`${BASE}deemedCancellation/confirmCancellation`, body);
  return res?.data;
}

// Flips a DeemedCancellation record to "Released" after the frontend has already run the
// full genuine-cancellation charge/refund flow itself (see DeemedTab.jsx).
async function markReleased(body) {
  const res = await axios.post(`${BASE}deemedCancellation/markReleased`, body);
  return res?.data;
}

// Upload the extension attachment to Supabase storage, return its public URL.
async function uploadExtensionAttachment(deemedCancellationId, file) {
  const ext = (file?.name?.split(".").pop() || "pdf").toLowerCase();
  const path = `deemed_extensions/${deemedCancellationId}_${file?.name || "attachment"}.${ext}`;
  const { error } = await supabase.storage.from(EXTENSION_BUCKET).upload(path, file, { upsert: true });
  if (error) throw error;
  const { data } = supabase.storage.from(EXTENSION_BUCKET).getPublicUrl(path);
  return data?.publicURL || null;
}

export { getDeemedList, grantExtension, confirmCancellation, markReleased, uploadExtensionAttachment };
